import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import { motion } from "framer-motion";
import { useRef } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import truck_sand_fill from "../assets/truck_sand_fill.jpg";
import truck_queue from "../assets/truck_queue.jpg";
import truck_sand_river from "../assets/truck_sand_river.jpg";
import base_construction_portraight from "../assets/base_construction_portraight.jpg";
import rocks_gitti from "../assets/rocks_gitti.jpg";
import raod_build from "../assets/raod_build.jpg";
import roadside from "../assets/roadside.jpg";

const carouselImages = [
  truck_sand_fill,
  truck_sand_river,
  truck_queue,
  "https://rstheme.com/products/wordpress/konstruk/wp-content/uploads/2022/10/portfolio2-520x640.jpg",
  "https://rstheme.com/products/wordpress/konstruk/wp-content/uploads/2022/10/portfolio5-520x640.jpg",
  base_construction_portraight,
  rocks_gitti,
  raod_build,
  roadside,
];
const Image_SliderSection = () => {
  const swiperRef = useRef(null);
  return (
    <div>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <Box
          sx={{
            backgroundColor: "#d20000",
            color: "#fff",
            padding: "80px 0",
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4}>
              {/* LEFT TITLE SIDE */}
              <Grid item xs={12} md={12}>
                <motion.div
                  initial={{ opacity: 0, x: -60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ duration: 0.5, ease: "easeOut" }}
                >
                  <Typography
                    variant="subtitle2"
                    className="paraAfter-line"
                    sx={{ marginBottom: "20px" }}
                  >
                    PROJECTS SNAPSHOTS
                  </Typography>

                  <Typography
                    variant="h1"
                    className="headPara"
                    sx={{
                      fontWeight: 700,
                      mb: 3,
                      lineHeight: 1.2,
                      color: "#fff",
                    }}
                  >
                    We Always Think On Your Dream
                  </Typography>
                </motion.div>
              </Grid>

              {/* RIGHT EMPTY */}
              {/* <Grid item xs={12} md={6}></Grid> */}

              {/* === CAROUSEL SECTION === */}
              <Grid item xs={12} sx={{ position: "relative", left: "-185px" }}>
                <motion.div
                  initial={{ opacity: 0, x: 60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  sx={{ position: "relative" }}
                >
                  <Swiper
                    // modules={[Autoplay]}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    spaceBetween={20}
                    slidesPerView={4}
                    loop
                    // autoplay={{ delay: 2500 }}
                    navigation
                    className="sliderHome"
                    breakpoints={{
                      0: { slidesPerView: 1 },
                      600: { slidesPerView: 2 },
                      900: { slidesPerView: 3 },
                    }}
                    style={{ paddingTop: "20px", color: "#fff" }}
                  >
                    {carouselImages.map((img, index) => (
                      <SwiperSlide key={index}>
                        <Box
                          sx={{
                            position: "relative",
                            overflow: "hidden",
                            borderRadius: "10px",
                            height: { xs: "300px", md: "500px" },
                          }}
                        >
                          {/* Image */}
                          <Box
                            component="img"
                            src={img}
                            alt={`project-${index}`}
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              transition: "0.4s",
                            }}
                          />

                          {/* Overlay */}
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              background: "#5d030380",
                              transition: "transform 0.4s ease",
                              transform: "translateY(0%)",
                            }}
                            className="overlayLayer"
                          />
                        </Box>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <Box
                    sx={{
                      position: "absolute",
                      right: "-140px",
                      top: "50%",
                      display: "flex",
                      gap: 2,
                    }}
                  >
                    <Box
                      onClick={() => swiperRef.current?.slidePrev()}
                      className="sliderArrow"
                    >
                      {"<"}
                    </Box>

                    <Box
                      onClick={() => swiperRef.current?.slideNext()}
                      className="sliderArrow"
                    >
                      {">"}
                    </Box>
                  </Box>
                </motion.div>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </motion.div>
    </div>
  );
};

export default Image_SliderSection;
